import { Input } from 'src/@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/@/components/ui/select';
import { Switch } from 'src/@/components/ui/switch';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function ModalScoring({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
  tipo,
  changeTipo,
  pontos,
  changePontos,
  status,
  changeStatus,
}) {
  const { t } = useTranslation('settings');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]" style={{ fontFamily: D.fontStack }}>
        <DialogHeader>
          <DialogTitle className={D.dialogTitle}>
            {action === 'Criar'
              ? t('funnel.scoring.modal.createTitle', 'Criar regra de score')
              : t('funnel.scoring.modal.editTitle', 'Editar regra de score')}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-5 py-2">
          <div className={D.field}>
            <label className={D.label}>{t('labels.name', 'Nome', { ns: 'common' })}</label>
            <Input
              onChange={changeNome}
              value={nome}
              placeholder={t('funnel.scoring.modal.namePlaceholder', 'Ex: Respondeu email')}
              className={D.input}
            />
          </div>
          <div className={D.grid2}>
            <div className={D.field}>
              <label className={D.label}>{t('labels.type', 'Tipo', { ns: 'common' })}</label>
              <Select value={tipo} onValueChange={changeTipo}>
                <SelectTrigger className={D.select}>
                  <SelectValue placeholder={t('funnel.scoring.modal.typePlaceholder', 'Selecione o tipo')} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="credit">{t('funnel.scoring.modal.creditOption', 'Crédito (+)')}</SelectItem>
                  <SelectItem value="debit">{t('funnel.scoring.modal.debitOption', 'Débito (-)')}</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className={D.field}>
              <label className={D.label}>{t('funnel.scoring.pointsLabel', 'Pontos')}</label>
              <Input
                type="number"
                min="1"
                onChange={changePontos}
                value={pontos}
                placeholder={t('funnel.scoring.modal.pointsPlaceholder', 'Ex: 10')}
                className={D.input}
              />
            </div>
          </div>
          <div className={`${D.toggleRow} border-t border-[#f0f0f3]`}>
            <div className={D.toggleRowMain}>
              <p className={D.toggleRowLabel}>{t('status.active', 'Ativo', { ns: 'common' })}</p>
              <p className={D.toggleRowHelp}>
                {t('funnel.scoring.modal.activeHint', 'Regras inativas deixam de pontuar novos eventos.')}
              </p>
            </div>
            <Switch
              className={D.switch}
              checked={status === 'true'}
              onCheckedChange={(checked) => changeStatus(checked ? 'true' : 'false')}
            />
          </div>
        </div>
        <DialogFooter className={D.dialogFooter}>
          <button type="button" className={D.ghostButton} onClick={onClose}>
            {t('buttons.cancel', { ns: 'common' })}
          </button>
          <button type="button" className={D.primaryButton} onClick={onSubmit}>
            {action === 'Criar' ? t('buttons.create', 'Criar', { ns: 'common' }) : t('buttons.save', 'Salvar', { ns: 'common' })}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
